import { ref } from "vue";
import { defineStore } from "pinia";
import ApiService from "@/core/services/ApiService";
import { LocalityEntity, SystemInitDto, UserWithSimpleInfoDto  } from "../core/services/ApiClient";
var ids = [];
var timeOut;
const localityData = ref<LocalityEntity[]>([]);
export const useSystemStore = defineStore("system", () => {
    const systemData = ref<SystemInitDto>();
    const users = ref<UserWithSimpleInfoDto[]>([]);
    const newsCount = ref<null>();
    const isInited = ref(false);
    async function init() {
        const response =await ApiService.apiClient.initSystem()
        if (response.data) {
            isInited.value = true
            systemData.value = response.data;
            users.value = response.data.users || [];
        }
    }

 function newsGetCount() {
     ApiService.apiClient.newsGetCount().then((response) => {
        if (response.data) {
            newsCount.value = response.data;
            console.log("response", newsCount.value)
       
         }
     });
    }

    function localityGetByIds(id: number) {
        if (ids.indexOf(id) == -1)
            ids.push(id);
        if (!timeOut) {
            timeOut = setTimeout(() => {
                ApiService.apiClient.localityGetByIds(ids).then((response) => {
                    ids = [];
                    clearTimeout(timeOut);
                    timeOut = 0;
                    if (response.data) {
                        localityData.value = response.data;
                    }
                });
            }, 500);
        }
    }

    return {
        isInited,
        systemData,
        users,
        init,
        newsCount,
        localityGetByIds,
        localityData,
        newsGetCount
    };
});
